import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-iumb3e-0"
})(["display:flex;flex-flow:column;flex-grow:1;flex-shrink:0;justify-content:center;width:100%;padding:24px;border:1px solid ", ";border-radius:8px;box-shadow:", ";margin-bottom:1rem;background-color:", ";text-align:center;:hover{box-shadow:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.cardsBackgroundColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.extraBlack;
});
export var InnerContainer = styled.div.withConfig({
  displayName: "Inner__InnerContainer",
  componentId: "sc-iumb3e-1"
})(["padding:24px;text-align:center;"]);